import Vue from "vue";
import { ElDialog } from "element-ui";
import ElDialogConfirm from "@/views/wiki/components/ElDialogConfirm.vue";

let dialogInstance = null;

/**
 * 显示 el-dialog 弹窗，返回 Promise
 * @param {string} message 弹窗消息
 * @returns {Promise<boolean>} 用户点击确定返回 true，取消返回 false
 */
export function showElDialogConfirm(message) {
  return new Promise(resolve => {
    // 如果已有 Dialog 实例，先销毁
    if (dialogInstance) {
      dialogInstance.$destroy();
    }

    // 创建一个新的 Vue 实例来挂载 Dialog
    const DialogWrapper = Vue.extend({
      render(h) {
        return h(ElDialogConfirm, {
          props: {
            message
          },
          on: {
            confirm: () => {
              resolve(true); // 用户点击确定
              dialogInstance.$destroy();
              dialogInstance = null;
            },
            cancel: () => {
              resolve(false); // 用户点击取消
              dialogInstance.$destroy();
              dialogInstance = null;
            }
          }
        });
      }
    });

    // 挂载到 body
    dialogInstance = new DialogWrapper().$mount();
    document.body.appendChild(dialogInstance.$el);
  });
}
